export default __webpack_public_path__ + "static/media/script-trimmed-linux.f91108ec.avif";